import { Routes, Route } from "react-router-dom"
import { Movies } from "../Components/Movies/Movies"
import { Trending } from "../Components/Trending/Trending"
import { TvSeries } from './../Components/TVSeries/TvSeries';
import { Search } from './../Components/Search/Search';



export const MainRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Trending />}></Route>
            <Route path="/movies" element={<Movies />}></Route>
            <Route path="/tvSeries" element={<TvSeries />}></Route>
            <Route path="/search" element={<Search />}></Route>
        </Routes>
    )
}